const InvoiceStates = {
    new: 'Nuevo',
    copy: 'Copia',
    modified: 'Modificado',
    corrected: 'Corregido',
    printed: 'Impreso',
    settled: "Liquidado"
}

module.exports = InvoiceStates;